import { Row, Col, Card, Empty } from 'antd';
import { ExclamationCircleFilled, CheckCircleFilled, EditOutlined, DeleteOutlined } from "@ant-design/icons"
import { useRecoilValue } from 'recoil';
import { inwardPartner } from '../../store/gloabalState';

const DirectorCard = ({
    directors,
    selectionValue,
    mode, 
    directorsID,
    showDeleteConfirm,
    editDirectorFun
}) => {

  const inwardPartnerState = useRecoilValue(inwardPartner)

    return(
        <>
        {directors?.length > 0 ? (
            <div
              style={{
                maxHeight: "75vh",
                overflowY: "scroll",
                overflowX: "hidden"
              }}
            >
              <Row gutter={[20, 20]}>
                {directors?.map((elem, i) => {
                  // let dob_: any;
                  // if (elem.dob !== null && elem.dob !== "null") {
                  //   dob_ = elem?.dob;
  
                  // }
                  return (
                    <div key={i}>
                      <Col span={12} key={elem?.id}>
                        <Card
                          className="directors_card"
                          title={<b>{elem?.name}</b>}
                          style={{
                            width: 400,
                            borderRadius: "5px",
                            border: "0.9px solid rgba(0,0,0,0.3)",
                            overflow: "hidden"
                          }}
                          disabled={mode === 'view' ? true : false}
                          bordered
                          hoverable
                          extra={
                            directorsID?.length ? (
                              directorsID.includes(elem?.id) ? (
                                
                                <>
                                  <CheckCircleFilled
                                    style={{
                                      color: "green",
                                      fontSize: "16px"
                                    }}
                                  />
                                </>
                              ) : (
                                <>
                                  <ExclamationCircleFilled
                                    style={{
                                      color: "red",
                                      fontSize: "16px"
                                    }}
                                  />
                                </>
                              )
                            ) : (
                              <>
                                <ExclamationCircleFilled
                                  style={{
                                    color: "red",
                                    fontSize: "16px"
                                  }}
                                />
                              </>
                            )
                          }
                          actions={[
                            <DeleteOutlined
                              key={"delete"}
                              style={
                                (mode === "view")
                                  ? { color: "red", opacity: ".3" }
                                  : { color: "red" }
                              }
                              onClick={() =>
                                mode !== 'view' &&
                                showDeleteConfirm(elem, "director")
                              }
                              disabled={mode === "view"}
                            />,
                            <EditOutlined
                              key="edit"
                              onClick={() => {
                                mode !== 'view' &&
                                  editDirectorFun(elem)
                              }}
                            />
                          ]}
                        >
                          {selectionValue === "outward" ||
                            selectionValue === "both" ? (
                            <>
                              <p>
                                DIN: <span>{elem.din}</span>
                              </p>
                              <p>
                                Date of Appointment:{" "}
                                <span>
                                  {elem?.dateOfAppointment
                                    ? elem?.dateOfAppointment
                                    : "-"}
                                </span>
                              </p>
                            </>
                          ) : (
                            ""
                          )}
                          <p>
                            Email:{" "}
                            <span>{elem.emailId ? elem.emailId : "-"}</span>
                          </p>
                          <p>
                            {elem.nationality === "IN" ||
                              elem.nationality === "Indian" ||
                              elem.nationality === null
                              ? "PAN"
                              : "PASSPORT"}
                            :{" "}
                            <span>
                              {elem.panNumber
                                ? elem.panNumber.toUpperCase()
                                : "-"}
                            </span>
                          </p>
                          {
                            !inwardPartnerState.includes("payglocal") &&
                            <p>
                            Nationality:{" "}
                            <span>
                              {elem.nationality === "IN" ||
                                elem.nationality === "Indian"
                                ? "Indian"
                                : elem?.nationality}
                            </span>
                          </p>
                          }
                          
                        </Card>
                      </Col>
                    </div>
                  )
                })}
              </Row>
            </div>
          ) : (
            <>
              <Empty description={<span>No directors data present</span>} />
            </>
          )}
          </>
    )
}

export default DirectorCard;